import { render, staticRenderFns } from "./ServiceAccess.vue?vue&type=template&id=2950caa4&scoped=true"
import script from "./ServiceAccess.vue?vue&type=script&lang=js"
export * from "./ServiceAccess.vue?vue&type=script&lang=js"
import style0 from "./ServiceAccess.vue?vue&type=style&index=0&id=2950caa4&prod&scoped=true&lang=css"
import style1 from "./ServiceAccess.vue?vue&type=style&index=1&id=2950caa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2950caa4",
  null
  
)

export default component.exports